var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"rounded-button",class:{
    'primary-type': _vm.type == 'primary',
    'white-type': _vm.type == 'white',
    disabled: _vm.disabled,
  },attrs:{"disabled":_vm.disabled}},[_c('div',[_c('div',{staticClass:"icon-left"},[_vm._t("icon-left")],2),_vm._t("default"),_c('div',{staticClass:"icon-right"},[_vm._t("icon-right")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }